module.exports = __webpack_public_path__ + "img/Bloomキャリア登録logo2.8abbe342.svg";